/**
 * Scroll back to `target` once the page is tall enough to get there.
 * A listing renders its products after an API call, so an immediate
 * scrollTo would stop short. Gives up after `timeoutMs`, or as soon as the
 * user scrolls themselves. Returns a cancel function.
 */
export function restoreScroll(target, { timeoutMs = 3000, win = window } = {}) {
  let done = false;
  let frame = 0;
  const started = Date.now();
  const stop = () => {
    done = true;
    win.cancelAnimationFrame(frame);
    for (const ev of USER_SCROLL_EVENTS) win.removeEventListener(ev, stop);
  };
  const step = () => {
    if (done) return;
    const maxY = win.document.documentElement.scrollHeight - win.innerHeight;
    win.scrollTo(0, Math.min(target, Math.max(0, maxY)));
    if (maxY >= target || Date.now() - started > timeoutMs) stop();
    else frame = win.requestAnimationFrame(step);
  };
  for (const ev of USER_SCROLL_EVENTS) win.addEventListener(ev, stop, { passive: true });
  step();
  return stop;
}

const USER_SCROLL_EVENTS = ["wheel", "touchstart", "keydown"];
